import React from "react";
import { optimized } from "./img";
import { useContentValue } from "../../ContentContext";

export const Patio = () => {
    const p = useContentValue("patio", {
        photo: "https://customer-assets.emergentagent.com/job_local-strake/artifacts/fj5b4098_att.q2d1m94bupi_xuDFQHRC0bVcZKx0Q59Sq4LCizeTJPk.jpeg",
        kicker: "Stay A While",
        title_line_1: "Your Local",
        title_line_2: "Collingwood",
        title_line_3: "Hangout.",
        subtitle: "Good Food • Good Vibes",
        body: "Dog Friendly Patio",
    });
    return (
        <section
            data-testid="patio-section"
            className="relative h-[78vh] min-h-[560px] w-full overflow-hidden grain"
        >
            <img
                src={optimized(p.photo, { w: 1100, q: 78 })}
                alt="Strake Collingwood patio"
                className="absolute inset-0 w-full h-full object-cover animate-[slowZoom_24s_ease-out_forwards]"
                style={{
                    objectPosition: "55% 40%",
                    filter: "brightness(1.05) saturate(1.1) contrast(1.03)",
                }}
                loading="lazy"
                decoding="async"
            />

            <div className="absolute inset-0 bg-gradient-to-b from-[#1A1410]/15 via-[#1A1410]/25 to-[#1A1410]/75" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_30%,rgba(232,168,124,0.12),transparent_55%)] mix-blend-screen" />

            <div className="relative z-10 h-full flex flex-col justify-end items-start px-6 pb-14 pt-12">
                <div className="text-[#E8A87C] text-[10px] uppercase tracking-[0.4em] font-semibold mb-5 font-body [text-shadow:_0_1px_4px_rgba(0,0,0,0.6)]">
                    — {p.kicker}
                </div>
                <h2 className="font-display text-white uppercase font-bold leading-[0.92] tracking-tight text-[44px] sm:text-6xl [text-shadow:_0_3px_18px_rgba(0,0,0,0.65)]">
                    {p.title_line_1}
                    <br />
                    {p.title_line_2}
                    <br />
                    <span className="italic font-normal text-[#E8A87C]">{p.title_line_3}</span>
                </h2>

                <div className="mt-8 space-y-3 max-w-md">
                    <div className="text-white font-display text-xl sm:text-2xl uppercase font-medium tracking-tight [text-shadow:_0_2px_10px_rgba(0,0,0,0.6)]">
                        {p.subtitle}
                    </div>
                    <div className="text-white/95 font-display text-lg sm:text-xl uppercase tracking-wide [text-shadow:_0_2px_10px_rgba(0,0,0,0.6)]">
                        {p.body}
                    </div>
                </div>
            </div>
        </section>
    );
};
